export default class BtnSendAnimation {

    static init() {
        document.querySelectorAll('.btn-send').forEach((btnSend) => {
            window.addEventListener('btn-send:animate', (data) => {
                if (btnSend.getAttribute('id') === data.detail.id) {
                    btnSend.querySelector('.frame').classList.add('active');
                    btnSend.querySelector('.p1Anim').beginElement();
                    btnSend.querySelector('.p2Anim').beginElement();
                    btnSend.querySelector('.p3Anim').beginElement();
                    btnSend.querySelector('.p4Anim').beginElement();
                    btnSend.querySelector('.p4Anim').beginElement();
                    setTimeout(() => {
                        btnSend.querySelector('.frame').classList.remove('active');
                    }, 2500);
                }
            }, false);
        });
    }
}
